import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';
import { setModalContent, setModalOpen } from 'shared/redux/landingSlice';
import { selectIsModalOpen } from 'shared/selectors/landing/selectIsModalOpen';
import { IRow } from '../../repositories/mortgage-broker-calculator/entities/mortgage_listing/Row';
import { selectModalWindowContent } from '../../selectors/landing';

interface IUseCreditInfoModal {
  isModalOpen: boolean;
  handleModalClose: () => void;
  handleModalOpen: (content: IRow[]) => void;
  modalContent?: IRow[] | null;
}

export const useCreditInfoModal = (): IUseCreditInfoModal => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsModalOpen);
  const modalContent = useSelector(selectModalWindowContent);

  const handleModalClose = React.useCallback(() => {
    dispatch(setModalOpen(false));
    dispatch(setModalContent(null));
  }, [dispatch]);

  const handleModalOpen = (content: IRow[]) => {
    dispatch(setModalContent(content));
    dispatch(setModalOpen(true));
  };

  return {
    isModalOpen,
    handleModalClose,
    handleModalOpen,
    modalContent,
  };
};
